<template>
	<TransitionGroup
		v-if="group"
		name="expand"
		@enter="enterHook"
		@leave="leaveHook"
	>
		<slot />
	</TransitionGroup>
	<Transition
		v-else
		name="expand"
		@enter="enterHook"
		@leave="leaveHook"
	>
		<slot />
	</Transition>
</template>
<script setup lang="ts">
	import {gsap} from 'gsap';

	interface Props {
		group?: boolean
	}

	defineProps<Props>();

	const enterHook = (el: Element, done: () => void): void => {
		gsap.from(el, {
			height: 0,
			opacity: 0,
			duration: 0.4,
			ease: 'power2.inOut',
			clearProps: 'height,opacity',
			onComplete: () => {
				done();
			},
		});
	};

	const leaveHook = (el: Element, done: () => void): void => {
		gsap.to(el, {
			height: 0,
			opacity: 0,
			duration: 0.4,
			ease: 'power2.inOut',
			clearProps: 'height,opacity',
			onComplete: () => {
				done();
			},
		});
	};
</script>
